import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DateSelectComponent, RelativeDatePipe } from './date-select.component';
import { FormsModule } from '@angular/forms';
import { SvgIconModule } from '../../components/svg-icon';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';

// Exports
export { DateSelectComponent, RelativeDatePipe } from './date-select.component'

@NgModule({
    declarations: [DateSelectComponent, RelativeDatePipe],
    imports: [
        CommonModule,
        FormsModule,
        SvgIconModule,
        MatDatepickerModule,
        MatNativeDateModule
    ],
    exports: [DateSelectComponent, RelativeDatePipe]
})
export class DateSelectModule { }
